<template>
    <transition name="fade" v-if="userInfo.isDietitian == false">
      <div class="not-dietitian-shadow">
        <div class="not-dietitian-info-flex-container">
          <div class="not-dietitian-info-flex-item">
            <div class="not-dietitian-info-title">Upewnij się, że jesteś zalogowany na koncie dietetyka.</div>
            <div class="not-dietitian-info-text">
              Jesteś na stronie zakupu programu Kcalmar.pro dla dietetyków. Konto pacjenta na którym jesteś obecnie zalogowany nie ma możliwości zakupu programu dla dietetyków.
            </div>
            <div class="not-dietitian-info-text-strong">
              Jeżeli chcesz kupić program Kcalmar.pro zaloguj się na:
            </div>
            <div class="not-dietitian-info-button">
              <a href="https://kcalmar.com/dietetyk/" class="next-step-button button">konto dietetyka</a>
            </div>
            <div class="not-dietitian-info-text">
              W razie pytań skontaktuj się z naszym biurem obsługi klienta<br>
              pod numerem tel.: <span class="not-dietitian-info-phone">783 539 157</span> lub na adres mailowy: <a href="mailto:kontakt@kcalmar.com" class="not-dietitian-info-email">kontakt@kcalmar.com</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PopupPatient',
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  }
}
</script>

<style scoped>
.not-dietitian-shadow {
  background: rgba(0, 0, 0, 0.8);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
}
.not-dietitian-info-flex-container {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.not-dietitian-info-flex-item {
  background-color: #FFFFFF;
  border-radius: 5px;
  color: #4A4A4A;
  font-family: 'Roboto-Regular';
  font-size: 15px;
  font-weight: 400;
  line-height: 30px;
  opacity: 1;
  padding: 60px 70px;
  text-align: center;
  width: 600px;
}
.not-dietitian-info-title {
  color: #000000;
  font-size: 38px;
  font-weight: 300;
  line-height: 54px;
  margin: 0 10px 30px 10px;
}
.not-dietitian-info-text-strong {
  font-weight: bold;
  margin-bottom: 30px;
}
.not-dietitian-info-button {
  font-weight: bold;
  margin-bottom: 30px;
}
.not-dietitian-info-phone{
  color: #41CDA8;
}
.not-dietitian-info-email {
  color: #41CDA8;
  text-decoration: underline;
}
</style>
